import TeamRenderer from "Components/ModelRenderers/TeamRenderer";
import IStyle from "Interfaces/IStyle";
import { TowerFloorTsvRow } from "Models/ClearUnitTsv";
import TeamFormation from "Models/TeamFormation";
import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";
const styles:IStyle = {
	student: {
		// padding: 2
	}
}
function TowerFloorRowTeamRenderer(props: {model: TeamFormation, label?: string, sublabel?: string, compact?: boolean}) {
	const {model, label, sublabel, compact} = props;
	if (!!!model) return null;
	let striker=0;
	let special=0;
	return (
		<Row className="" style={{margin:5, padding:5}}>
			{/* <Col lg={2} className="text-center">
				<Sticky offset={70}>
					<h3 className="text-pink">{label ?? "Unit"}</h3>
					<h5 className="text-pink">{sublabel}</h5>
				</Sticky>
			</Col> */}
			<Col>
				<TeamRenderer team={model.strikers} compact={compact} />
				<TeamRenderer team={model.specials} compact={compact} />
			</Col>
		</Row>
	)
}

export default function TowerFloorRowRenderer(props: {model:TowerFloorTsvRow, compact?: boolean}) {
	const {model, compact} = props;
	return (
	<Row>
		<Col>
			<Accordion defaultActiveKey="0" className="block">
				<Accordion.Item eventKey="0">
					<Accordion.Header>Floor {model.floor}</Accordion.Header>
					<Accordion.Body>
						<Row>
							{/* <Col  xs={12} md={2} lg={2} className="text-center">
								<Sticky offset={70}>
									<Row>
										<Col>
											<Image style={{maxWidth: 50}} src={model?.getTierIcon()}></Image>
											<TagBadge>{model?.getTier()}</TagBadge>
										</Col>
									</Row>
								</Sticky>
							</Col> */}

							<Col>
								<TowerFloorRowTeamRenderer compact={compact} model={model.team} />
							</Col>
						</Row>
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>
		</Col>
	</Row>);
}
